import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="disable"
export default class extends Controller {
  static values = { with: { type: String, default: "Merci de patienter..."}}
  static targets = [ 'button' ]

  showMessage(event) {
    this.buttonTarget.disabled = "disabled";
    this.buttonTarget.innerHTML = this.withValue;
  }
}
